<template>
  <LcBadge v-bind="CONFIG[status]">
    {{ $t(`myorders.status.playslip.${status}`) }}
  </LcBadge>
</template>

<script lang="ts" setup>
import type { LcIconName } from '@lottocom/frontend-components'

import { PlaySlipOrderStatus } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersStatusBadgeSingleOrderProps = {
  status: PlaySlipOrderStatus
}

type StatusBadge = {
  class: string
  icon: LcIconName
}

defineProps<MyOrdersStatusBadgeSingleOrderProps>()

const CONFIG: Record<PlaySlipOrderStatus, StatusBadge> = {
  [PlaySlipOrderStatus.Cancelled]: {
    class: 'bg-accent-danger-danger',
    icon: 'orders-canceled',
  },
  [PlaySlipOrderStatus.Closed]: {
    class: 'bg-accent-danger-danger',
    icon: 'orders-purchased',
  },
  [PlaySlipOrderStatus.Ordered]: {
    class: 'bg-secondary-secondary-bold',
    icon: 'orders-waiting-for-purchase',
  },
  [PlaySlipOrderStatus.Purchased]: {
    class: 'bg-accent-info-info-light',
    icon: 'orders-purchased',
  },
}
</script>
